<template>
  <div class="salesforce-logs-page">
    <!-- Header (matching monitoring page styling) -->
    <div class="bg-white shadow-sm border-b">
      <div class="px-6 py-4">
        <div class="flex justify-between items-center">
          <div>
            <h1 class="text-2xl font-semibold text-gray-900">Salesforce Sync Logs</h1>
            <p class="text-sm text-gray-600 mt-1">View and manage synchronization history with Salesforce</p>
          </div>
          <div>
            <a href="/admin/salesforce" class="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors">
              <i class="fas fa-arrow-left mr-2"></i>Back to Settings
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Main Content Area -->
    <div class="p-6">
      <!-- Wrap SyncHistory in a white background container like monitoring page -->
      <div class="bg-white rounded-lg shadow">
        <div class="p-6">
          <sync-history />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SyncHistory from './SyncHistory.vue';

export default {
  name: 'SalesforceLogsPage',
  components: {
    SyncHistory
  }
}
</script>

<style scoped>
/* Ensure full height layout */
.salesforce-logs-page {
  min-height: calc(100vh - 64px); /* Adjust based on your header height */
  background-color: #f3f4f6; /* Match Tailwind's gray-100 for consistency */
}
</style>